import styled from "styled-components"
import { Drawer } from "@mui/material"

const DataTableWrapper = styled(Drawer)`
  .MuiDrawer-paper {
    width: min(980px, calc(100vw - 28px));
    border-radius: 18px 0 0 18px;
    border-left: 1px solid var(--cms-border);
    background: var(--cms-dialog-bg);
    box-shadow: -16px 0 40px rgba(15, 23, 42, 0.16);
    padding: 10px 14px 14px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .dt-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 8px 4px 2px;

    .title {
      margin: 0;
      font-size: 18px;
      line-height: 1.2;
      font-weight: 700;
      color: var(--cms-text-primary);
    }
  }

  .dt-summary {
    padding: 6px 4px 2px;
  }

  .dt-grid {
    flex: 1;
    min-height: 420px;
    margin-top: 8px;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid var(--cms-border);
    background: var(--cms-surface-secondary);
  }

  .MuiDataGrid-columnHeaders {
    background: var(--cms-table-head-bg);
  }

  .MuiDataGrid-columnHeaderTitle {
    font-weight: 700 !important;
    color: var(--cms-text-primary);
  }

  .MuiDataGrid-cell {
    color: var(--cms-text-primary);
  }

  .MuiDialogActions-root,
  .dt-actions {
    display: flex;
    justify-content: flex-end;
    padding: 10px 2px 0;
  }
`

export { DataTableWrapper }
